<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="visible"
            :width="width"
            :height="height"
            :modal="modal"
            :before-close="beforeClose"
            :close-on-click-modal="closeOnClickModal"
            :showRight="showRight"
            :center="center"
        >
            <div class="mainDialogLayout">
                <slot></slot>
                <div class="leftContentLayout">
                    <slot name="leftContent"></slot>
                </div>
                <div class="rightContentLayout" v-if="showRight">
                    <slot name="rightContent"></slot>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <slot name="buttonGroup">
                    <el-button type="primary" @click="cancel">{{$t('integration.cancel')}}</el-button>
                    <el-button type="primary" @click="confirm">{{$t('integration.confirm')}}</el-button>
                </slot>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'Dialog',
    props: {
        //  对话框标题
        title: {
            type: String,
            default: () => $t('integration.tips')
        },
        //  对话框宽度
        width: {
            type: String,
            default: '500px'
        },
        //  对话框高度
        height: {
            type: String,
            default: '500px'
        },
        //  是否显示模态框
        modal: {
            type: Boolean,
            default: true
        },
        //  是否显示
        visible: {
            type: Boolean,
            default: false
        },
        //  是否点击模态框外部可以关闭对话框
        closeOnClickModal: {
            type: Boolean,
            default: true
        },
        //  对话框标题和底部是否居中
        center: {
            type: Boolean,
            default: true
        },
        //  是否显示右侧内容
        showRight: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        beforeClose() {
            // 关闭前的回调，会暂停 Dialog 的关闭
            this.cancel();
        },
        cancel() {
            // 关闭弹窗，$emit触发自定义事件close
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    border: 5px solid $blue1;
    border-radius: 10px;
}
::v-deep .el-dialog__header {
    background-color: $blue1;
    padding: 5px 0;
    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        padding-left: 20px;
    }
    .el-dialog__close:hover {
        color: $txtcolor8;
        background-color: $red;
    }
}
::v-deep .el-dialog__headerbtn {
    top: 5px;
    i {
        color: $txtcolor1;
        font-size: 18px;
    }
}
::v-deep .el-form-item__label {
    width: auto;
    white-space: nowrap;
    text-align: right;
}

::v-deep .el-form-item__content {
    margin-left: 0;
}
::v-deep .el-dialog__footer {
    text-align: center;
    padding: 10px 0;
}
.mainDialogLayout {
    display: flex;
    max-height: 500px;
    overflow: auto;
}
.leftContentLayout,
.rightContentLayout {
    flex: 1;
}
.leftContentLayout {
    max-height: 500px;
    overflow: auto;
}
</style>
